import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { CircleCheck, X } from 'lucide-react';
import { useFocusToast } from './useFocusToast';

export interface FocusSuccessToastHandle {
  show: (summary: string, detail: string) => void;
}

export const FocusSuccessToast = forwardRef<FocusSuccessToastHandle>(function FocusSuccessToast(_props, ref) {
  const toastRef = useRef<Toast>(null);
  const showFocusToast = useFocusToast(toastRef);
  useImperativeHandle(ref, () => ({ show: showFocusToast }), [showFocusToast]);

  return (
    <Toast
      ref={toastRef}
      position="top-right"
      appendTo={document.body}
      pt={{
        message: { className: '!tw-bg-transparent !tw-border-none !tw-shadow-none' },
        content: { className: '!tw-p-0' },
      }}
      className="tw-opacity-100"
      content={({ message }) => (
        <div className="tw-flex tw-w-full tw-items-start tw-gap-3 tw-border-2 tw-border-t-2 tw-border-solid tw-border-green-800 tw-border-b-8 tw-rounded-2xl tw-bg-green-700 tw-p-4 tw-text-neutral-0">
          <CircleCheck size={24} className="tw-shrink-0" aria-hidden />
          <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-2">
            <p className="tw-font-atkinson tw-text-white tw-m-0 tw-break-words tw-text-base tw-font-bold tw-leading-5">
              {message.summary}
            </p>
            <p className="tw-font-atkinson tw-text-white tw-m-0 tw-break-words tw-text-sm tw-font-normal tw-leading-5">
              {message.detail}
            </p>
          </div>
          <button
            type="button"
            onClick={() => toastRef.current?.remove(message)}
            aria-label="Dismiss"
            className="tw-flex tw-shrink-0 tw-cursor-pointer tw-border-none tw-bg-transparent tw-p-0 tw-text-neutral-0"
          >
            <X size={24} aria-hidden />
          </button>
        </div>
      )}
    />
  );
});
